import { Loader2, MapPin, Navigation, Clock } from "lucide-react";
import { useDriverTracking } from "../../hooks/useDriverPortal";

function fmtRelative(iso) {
  if (!iso) return "—";
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

function Row({ icon: Icon, label, value }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 0", borderTop: "1px solid #F3F4F6" }}>
      <Icon size={15} color="#9CA3AF" />
      <div>
        <div style={{ fontSize: 11.5, color: "#9CA3AF" }}>{label}</div>
        <div style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>{value || "—"}</div>
      </div>
    </div>
  );
}

// No refresh button here by design — tracking data is whatever the backend has
// already cached from FASTag toll crossings. A driver cannot trigger a live
// lookup or see any FASTag credential/API detail from this screen.
export default function DriverTracking() {
  const { data, loading } = useDriverTracking();

  if (loading) {
    return (
      <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader2 size={18} style={{ animation: "spin 1s linear infinite", color: "#9CA3AF" }} />
      </main>
    );
  }

  return (
    <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB" }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "28px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", marginBottom: 2 }}>Tracking</div>
        <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>Based on FASTag toll-crossing data — not live GPS</div>

        {!data?.tracking ? (
          <div style={{ background: "#fff", border: "1px dashed #D1D5DB", borderRadius: 14, padding: "48px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: "#374151" }}>No tracking data yet.</div>
          </div>
        ) : (
          <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "18px 20px" }}>
            <Row icon={Navigation} label="Movement Status" value={data.tracking.movementStatus} />
            <Row icon={MapPin} label="Current City / Location" value={data.tracking.currentCity} />
            <Row icon={MapPin} label="Last Toll Plaza" value={data.tracking.lastTollPlaza} />
            <Row icon={Clock} label="Last Updated" value={fmtRelative(data.tracking.lastUpdated)} />
            {data.tracking.noRecentData && (
              <div style={{ marginTop: 12, fontSize: 12.5, color: "#D97706", background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: 8, padding: "8px 12px" }}>
                No toll crossing recorded recently for this vehicle.
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  );
}
